var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlower = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-SenSys Logo Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0527304455 13.0120347 0.0527304455 13.0120347 13.0643564 0 13.0643564"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BMS-M-AP-Login",
    transform: "translate(-120.000000, -490.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(159.500000, 496.500000) rotate(-360.000000) translate(-159.500000, -496.500000) translate(120.000000, 490.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-SenSys-Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, -0.064356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.011649)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1067302,11.1587688 C8.56587376,13.6995609 4.44635396,13.6995609 1.90556188,11.1587688 C-0.635230198,8.61842723 -0.635230198,4.49903614 1.90556188,1.9581797 C4.44635396,-0.582419307 8.56587376,-0.582419307 11.1067302,1.9581797 C13.6471361,4.49903614 13.6471361,8.61842723 11.1067302,11.1587688",
    id: "Fill-1",
    fill: "#4C5A51",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.70334703,9.0597901 L6.60906485,11.3362703 L6.70334703,11.3362703 C6.70334703,8.80931485 8.75921337,6.75351287 11.2862332,6.75351287 L11.4834213,6.75351287 L11.4834213,6.55613168 C11.4834213,5.8177703 11.3193124,5.11718614 11.030352,4.48456238 C8.62187673,4.6177802 6.70334703,6.6187505 6.70334703,9.0597901",
    id: "Fill-4",
    fill: "#FED17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98188218,4.4845495 C1.69292178,5.11717327 1.5286198,5.81775743 1.5286198,6.55611881 L1.5286198,6.7535 L1.72593663,6.7535 C4.25276337,6.7535 6.30850099,8.80930198 6.30850099,11.3362574 L6.40291188,11.3362574 L6.30850099,9.05977723 C6.30850099,6.61873762 4.39003564,4.61776733 1.98188218,4.4845495",
    id: "Fill-6",
    fill: "#FED17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30312178,2.4392505 C7.76622574,3.17973564 6.70337921,4.75331485 6.70337921,6.5702901 L6.50593366,11.3362703 L6.60909703,11.3362703 L6.70337921,9.0597901 C6.70337921,6.6187505 8.62184455,4.6177802 11.0303842,4.48456238 C10.6515178,3.6557802 10.0537752,2.9487604 9.30312178,2.4392505",
    id: "Fill-8",
    fill: "#FDC44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30853317,6.57031584 C6.30853317,4.75327624 5.24562228,3.1798901 3.70885495,2.43927624 C2.95845891,2.94878614 2.36045891,3.65580594 1.98191436,4.48452376 C4.39006782,4.61780594 6.30853317,6.61871188 6.30853317,9.05981584 L6.40294406,11.336296 L6.50591436,11.336296 L6.30853317,6.57031584 Z",
    id: "Fill-10",
    fill: "#FDC44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30853317,6.57031584 L6.50591436,11.336296 L6.7033599,6.57031584 C6.7033599,4.75327624 7.76620644,3.17969703 9.30310248,2.43927624 C8.64827574,1.99470198 7.88140446,1.69814752 7.04361238,1.60817723 L6.88690446,1.59125149 L6.50591436,2.7039099 L6.12518168,1.59125149 L5.96853812,1.60817723 C5.13074604,1.69814752 4.36361733,1.99470198 3.70885495,2.43927624 C5.24562228,3.1798901 6.30853317,4.75327624 6.30853317,6.57031584",
    id: "Fill-12",
    fill: "#FCB813"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlower);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flower.a02f189af41603a73a11a31ab347055f.svg";